import { RouterProvider } from "react-router-dom";
import "./App.css";
import { router } from "./router/route";
import ToastProvider from "./components/toaster/toster";
import NavigationProvider from "./components/contextApi/NavigationProvide";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import ConfirmProvider from "./components/toaster/alert";

const App = () => {
  return (
    <>
      <Provider store={store}>
        <NavigationProvider>
          <ConfirmProvider>
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
          </ConfirmProvider>
        </NavigationProvider>
      </Provider>
    </>
  );
};

export default App;
